module.exports = __webpack_public_path__ + "img/Twitch_icon.8d072081.png";